<template>
    <div
        v-if="items && model"
        class="product-filter-colors"
    >
        <ProductsFilterTitle
            :name="items.name"
            :count="selectedCount"
        ></ProductsFilterTitle>
        <div>
            <ul
                class="color-swatches d-flex flex-row flex-wrap list-style-none mt-3 mb-0"
            >
                <template
                    v-for="attrObj in items.values"
                    :key="attrObj.uid"
                >
                    <ProductsFilterColorItem
                        :model-value="model[attrObj.uid!]!"
                        :attr-obj="attrObj"
                        @update:model-value="onChange(attrObj.uid!, $event)"
                    ></ProductsFilterColorItem>
                </template>
            </ul>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import ProductsFilterTitle from '~/components/products/products-list/ProductsFilterTitle/ProductsFilterTitle.vue';
    import ProductsFilterColorItem from '~/components/products/products-list/ProductsFilterColorItem/ProductsFilterColorItem.vue';
    import type {
        ProductFilterAttribute,
        ProductFilterModelItem
    } from '~/types';
    import { pausableFilter, watchWithFilter } from '@vueuse/core';

    const {
        eventFilter,
        pause,
        resume
    } = pausableFilter();

    const props = defineProps<{
        modelValue: Nilish<ProductFilterModelItem>;
        items: ProductFilterAttribute;
    }>();

    const emit = defineEmits<{
        'update:modelValue': [value: ProductFilterModelItem];
    }>();


    const model = ref<Nilish<ProductFilterModelItem>>(props.modelValue);
    const selectedCount = computed<number>(() => {
        return !model.value ? 0 : Object.values(model.value).filter((v) => !!v).length;
    });

    const unWatchModelValue = watchWithFilter(
        () => props.modelValue,
        (updatedModel: Nilish<ProductFilterModelItem>) => {
            model.value = updatedModel;
        },
        {
            eventFilter,
            immediate: true
        }
    );

    function onChange(uid: string, value: boolean) {
        if (model.value) {
            pause();
            model.value[uid] = !model.value[uid];
            emit('update:modelValue', model.value);
            setTimeout(() => resume?.(), 250);
        }
    }

    onBeforeUnmount(() => {
        unWatchModelValue?.();
    });
</script>

<style lang="scss">
.product-filter-colors {
    .color-swatches {
        padding: 0;
        gap: 0.6rem;
    }
}
</style>
